module.exports = __webpack_public_path__ + "img/norschach.dfb9611e.gif";